module.exports = __webpack_public_path__ + "img/Z60_13.63da9b3c.jpg";